import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { RentasLaboralAsalariadoModalComponent } from '../modales/renta-laboral/renta-laboral-asalariado/renta-laboral-asalariado-modal.component';
import { RentaLaboralPrestacionServiciosModalComponent } from '../modales/renta-laboral/renta-laboral-prestacion-servicios-modal/renta-laboral-prestacion-servicios-modal.component';
import { MatDialog, MatDialogRef } from '@angular/material';
import { DDocumento } from '@dian/api-formulario';
import { HandlerComponent, Question } from '../handler-component';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';
import { DOperacionesMatematicasServicio, DTipoOperacionAritmetica } from '@dian-cmp/formulario';
import { DValorDominio } from '@dian/api-basicos-parametricas';
import { MessageObservableService } from '../../../../services/message-observable.service';
import { RentaLaboralTecnicasModalComponent } from '../modales/renta-laboral/renta-laboral-tecnicas-modal/renta-laboral-tecnicas-modal.component';

const VAL_INDICADOR_COMPLETO="999";//Valor de referencia, si el indicador esta en este valor entonces ya paso todos los steps y el modal esta completo

const questions: Question[] = [
  {question: '¿Es usted asalariado?', field: 'cs_id_231', show: true, nextIfValue: "0", isCompleted: false, resp:"", hasSuggested: "0", totalField: "cs_id_"}, 
  {question: 'Como trabajador independiente, en Colombia o en el exterior, ¿usted tuvo ingresos por prestación de servicios en el sector privado o público, consultorías, asesorías, creación de obras artísticas, influenciadores o relacionados con profesiones liberales (todas las que reciben título universitario)?', field: 'cs_id_275', show: false, nextIfValue: "0", isCompleted: false, resp:"", hasSuggested: "0", totalField: "cs_id_"},  
  {question: 'Como trabajador independiente, en Colombia o en el exterior, ¿usted tuvo ingresos por actividades técnicas o de oficio (carpintería, mantenimiento de equipos, reparaciones en general, modistería u otros)?', field: 'cs_id_312', show: false, nextIfValue: "0", isCompleted: false, resp:"", hasSuggested: "0", totalField: "cs_id_"}
];

@Component({
  selector: 'app-renta-laboral',
  templateUrl: './renta-laboral.component.html',
  styleUrls: ['./renta-laboral.component.css']
})
export class RentaLaboralComponent extends HandlerComponent implements OnInit {

  @Input('listTiposDocumentos') tiposDocumentofiltrado: DValorDominio[] = [];
  @Input('listTiposParentesco') tiposParentesco: DValorDominio[] = [];
  
  @Input('model') model: DDocumento = new DDocumento();
  @Output('isCompleted') isCompleted: EventEmitter<boolean> = new EventEmitter<false>();
  @Output('saveModel') saveModel: EventEmitter<boolean> = new EventEmitter<false>();
  

  constructor(
    public dutilidades:DOperacionesMatematicasServicio, 
    public dNotificacionServicio: DNotificacionServicio,
    private dialog: MatDialog,
    private _messagesObs: MessageObservableService

  ) {
    super(questions);
  }

  
  ngOnInit() {
    this.initilizeQuestionsDesdeModelo(this.model);
    this.validateComponentCompleted();
  }

  validateQuestions(id: number) {
    console.log(id);

  }
  private listenMessagesObs() {
    this._messagesObs.getMessages().subscribe(res => {
        
    });
  }

  initilizeQuestionsDesdeModelo(model){
    for(let i=0; i<questions.length; i++){
      switch(i){
        case 0:
        questions[i].resp = model.doc.cuerpo.cs_id_231;  
        questions[i].isCompleted = ((model.doc.cuerpo.cs_id_231 != undefined && model.doc.cuerpo.cs_id_231 =="0") || (this.validateModalCompleted(i)));
        if(questions[i].isCompleted || model.doc.cuerpo.cs_id_231 == "1"){questions[i].show = true;}
          break;
        case 1:
        questions[i].resp = model.doc.cuerpo.cs_id_275;  
        questions[i].isCompleted = ((model.doc.cuerpo.cs_id_275 != undefined && model.doc.cuerpo.cs_id_275 =="0") || (this.validateModalCompleted(i)));
        if(questions[i].isCompleted || model.doc.cuerpo.cs_id_275 == "1"){questions[i].show = true;}
          break;
        case 2:
        questions[i].resp = model.doc.cuerpo.cs_id_312;  
        questions[i].isCompleted = ((model.doc.cuerpo.cs_id_312 != undefined && model.doc.cuerpo.cs_id_312 =="0") || (this.validateModalCompleted(i)));
        if(questions[i].isCompleted || model.doc.cuerpo.cs_id_312 == "1"){questions[i].show = true;}
          break;
        
      }
      this.checkNextQuestion(i);
    }
    
  }

  
  openModal(indexQuestionModal:number) {
    const config = {
      minHeight: '80vh',
      minWidth: '80%',
      disableClose: true,
      data: this.model
    };

    switch (indexQuestionModal) {
      case 0:
        let dialog0: MatDialogRef<RentasLaboralAsalariadoModalComponent> = this.dialog.open(RentasLaboralAsalariadoModalComponent, config);
        dialog0.componentInstance.tiposDocumentofiltrado = this.tiposDocumentofiltrado;
        dialog0.componentInstance.tiposParentesco = this.tiposParentesco;
        dialog0.componentInstance.saveModel.subscribe(() => {
          this.saveModel.emit(true);
        });
         dialog0.afterClosed().subscribe(data => {
          this.validateModalCompleted(indexQuestionModal);
        })
        break;
      case 1:
        let dialog1: MatDialogRef<RentaLaboralPrestacionServiciosModalComponent> = this.dialog.open(RentaLaboralPrestacionServiciosModalComponent, config);
        dialog1.componentInstance.tiposDocumentofiltrado = this.tiposDocumentofiltrado;
        dialog1.componentInstance.tiposParentesco = this.tiposParentesco;
        dialog1.componentInstance.saveModel.subscribe(() => {
          this.saveModel.emit(true);
        });
        dialog1.afterClosed().subscribe(data => {
          this.validateModalCompleted(indexQuestionModal);
        })
        break;
      case 2:
        let dialog2: MatDialogRef<RentaLaboralTecnicasModalComponent> = this.dialog.open(RentaLaboralTecnicasModalComponent, config);
        dialog2.componentInstance.tiposDocumentofiltrado = this.tiposDocumentofiltrado;
        dialog2.componentInstance.tiposParentesco = this.tiposParentesco;
        dialog2.componentInstance.saveModel.subscribe(() => {
          this.saveModel.emit(true);
        });
        dialog2.afterClosed().subscribe(data => {
          this.validateModalCompleted(indexQuestionModal);
        })
        break;  
    }
  }

  protected validateModalCompleted(indexQuestion:number):boolean{
    let isModalComplete:boolean = false;
    switch(indexQuestion){
      case 0:
        if( this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, this.model.doc.cuerpo.cs_id_309, VAL_INDICADOR_COMPLETO) ){
          isModalComplete=true;break;
        }
        break;
      case 1:
        if( this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, this.model.doc.cuerpo.cs_id_310, VAL_INDICADOR_COMPLETO) ){
          isModalComplete=true;break;
        }
        break;
      case 2:
        if( this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, this.model.doc.cuerpo.cs_id_311, VAL_INDICADOR_COMPLETO) ){
          isModalComplete=true;break;
        }
        break;
      
      default:
        break;
    }
    if(isModalComplete){
      questions[indexQuestion].isCompleted = true;
      if(questions.length > indexQuestion+1) questions[indexQuestion + 1].show = true;//Habilitar visibilidad de la siguiente pregunta
    }else{
      questions[indexQuestion].isCompleted = false;
      //if(questions.length > indexQuestion+1) questions[indexQuestion + 1].show = false;
    }
    this.validateComponentCompleted();
    return isModalComplete;
  }
  
  protected validateHasModalValues(indexQuestion:number):boolean{
    let hasValues:boolean = false;
    switch(indexQuestion){
      case 0:
        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_232, "0")){
          hasValues=true;break;
        }
        if(this.model.doc.cuerpo.cs_id_234!=null){
          hasValues=true;break;
        }
        break;
      case 1:
        if(this.model.doc.cuerpo.cs_id_277!=null){
          hasValues=true;break;
        }
        break;
      case 2:
        if(this.model.doc.cuerpo.cs_id_314!=null){
          hasValues=true;break;
        }
        break;
      
      default:
        return false;
    }
    return hasValues;
  }
  protected cleanModalValues(indexQuestionModal:number){
    switch(indexQuestionModal){
      case 0:
        this.model.doc.cuerpo.cs_id_232 = 0;
        this.model.doc.cuerpo.cs_id_233 = 0;
        this.model.doc.cuerpo.cs_id_234 = null;
        this.model.doc.cuerpo.cs_id_235 = 0;
        this.model.doc.cuerpo.cs_id_236 = 0;
        this.model.doc.cuerpo.cs_id_237 = 0;
        this.model.doc.cuerpo.cs_id_238 = 0;
        this.model.doc.cuerpo.cs_id_239 = 0;
        this.model.doc.cuerpo.cs_id_240 = 0;
        this.model.doc.cuerpo.cs_id_241 = 0;
        this.model.doc.cuerpo.cs_id_242 = 0;
        this.model.doc.cuerpo.cs_id_243 = 0;
        this.model.doc.cuerpo.cs_id_244 = 0;
        this.model.doc.cuerpo.cs_id_245 = 0;
        this.model.doc.cuerpo.cs_id_246 = 0;
        this.model.doc.cuerpo.cs_id_247 = 0;
        this.model.doc.cuerpo.cs_id_248 = 0;
        this.model.doc.cuerpo.cs_id_249 = 0;
        this.model.doc.cuerpo.cs_id_250 = 0;
        this.model.doc.cuerpo.cs_id_251 = 0;
        this.model.doc.cuerpo.cs_id_252 = 0;
        this.model.doc.cuerpo.cs_id_253 = 0;
        this.model.doc.cuerpo.cs_id_254 = 0;
        this.model.doc.cuerpo.cs_id_255 = 0;
        this.model.doc.cuerpo.cs_id_257 = 0;
        this.model.doc.cuerpo.cs_id_267 = 0;
        this.model.doc.cuerpo.cs_id_274 = 0;
        this.model.doc.cuerpo.cs_id_258 = 0;
        this.model.doc.cuerpo.cs_id_259 = 0;
        this.model.doc.cuerpo.cs_id_260 = 0;
        this.model.doc.cuerpo.cs_id_261 = 0;
        this.model.doc.cuerpo.cs_id_262 = null;
        this.model.doc.cuerpo.cs_id_263 = 0;
        this.model.doc.cuerpo.cs_id_264 = 0;
        this.model.doc.cuerpo.cs_id_265 = 0;
        this.model.doc.cuerpo.cs_id_266 = 0;
        this.model.doc.cuerpo.cs_id_268 = 0;
        this.model.doc.cuerpo.cs_id_269 = 0;
        this.model.doc.cuerpo.cs_id_473 = 0;
        this.model.doc.cuerpo.cs_id_267 = 0;
        this.model.doc.cuerpo.cs_id_268 = 0;
        this.model.doc.cuerpo.cs_id_270 = 0;
        this.model.doc.cuerpo.cs_id_271 = 0;
        this.model.doc.cuerpo.cs_id_272 = 0;
        this.model.doc.cuerpo.cs_id_273 = 0;
        this.model.doc.cuerpo.cs_id_960 = 0;
        this.model.doc.cuerpo.cs_id_309="0";//Indicador de Completo
        break;
      case 1:
        //TODO Completar campos
        this.model.doc.cuerpo.cs_id_277 = null;//seleccion
        this.model.doc.cuerpo.cs_id_278 = null;//Boolean
        this.model.doc.cuerpo.cs_id_279 = 0;//number
        this.model.doc.cuerpo.cs_id_280 = null;//Boolean
        this.model.doc.cuerpo.cs_id_281 = 0;//number
        this.model.doc.cuerpo.cs_id_282 = 0;//number
        this.model.doc.cuerpo.cs_id_283 = 0;//number
        this.model.doc.cuerpo.cs_id_284 = 0;//number
        this.model.doc.cuerpo.cs_id_285 = 0;//number
        this.model.doc.cuerpo.cs_id_286 = 0;//number
        this.model.doc.cuerpo.cs_id_287 = 0;//number
        this.model.doc.cuerpo.cs_id_288 = 0;//number
        this.model.doc.cuerpo.cs_id_290 = 0;//number
        this.model.doc.cuerpo.cs_id_291 = 0;//number
        this.model.doc.cuerpo.cs_id_292 = 0;//number
        this.model.doc.cuerpo.cs_id_293 = 0;//number
        this.model.doc.cuerpo.cs_id_294 = 0;//number
        this.model.doc.cuerpo.cs_id_295 = null;//Boolean
        this.model.doc.cuerpo.cs_id_296 = 0;//number
        this.model.doc.cuerpo.cs_id_297 = 0;//number
        this.model.doc.cuerpo.cs_id_298 = 0;//number
        this.model.doc.cuerpo.cs_id_299 = 0;//number
        this.model.doc.cuerpo.cs_id_300 = 0;//number
        this.model.doc.cuerpo.cs_id_301 = 0;//number
        this.model.doc.cuerpo.cs_id_302 = 0;//number
        this.model.doc.cuerpo.cs_id_303 = 0;//number
        this.model.doc.cuerpo.cs_id_304 = 0;//number
        this.model.doc.cuerpo.cs_id_305 = 0;//number
        this.model.doc.cuerpo.cs_id_306 = 0;//number
        this.model.doc.cuerpo.cs_id_307 = 0;//number
        this.model.doc.cuerpo.cs_id_308 = 0;//number
        this.model.doc.cuerpo.cs_id_310 = 0;//number
        this.model.doc.cuerpo.cs_id_311 = 0;//number
        this.model.doc.cuerpo.cs_id_316 = 0;//number
        this.model.doc.cuerpo.cs_id_317 = null;//Boolean
        this.model.doc.cuerpo.cs_id_318 = 0;//number
        this.model.doc.cuerpo.cs_id_319 = 0;//number
        this.model.doc.cuerpo.cs_id_320 = 0;//number
        this.model.doc.cuerpo.cs_id_321 = 0;//number
        this.model.doc.cuerpo.cs_id_322 = 0;//number
        this.model.doc.cuerpo.cs_id_323 = 0;//number
        this.model.doc.cuerpo.cs_id_324 = 0;//number
        this.model.doc.cuerpo.cs_id_325 = 0;//number
        this.model.doc.cuerpo.cs_id_326 = 0;//number
        this.model.doc.cuerpo.cs_id_327 = 0;//number
        this.model.doc.cuerpo.cs_id_328 = 0;//number
        this.model.doc.cuerpo.cs_id_329 = null;//Boolean
        this.model.doc.cuerpo.cs_id_330 = 0;//number
        this.model.doc.cuerpo.cs_id_331 = 0;//number
        this.model.doc.cuerpo.cs_id_332 = 0;//number
        this.model.doc.cuerpo.cs_id_333 = 0;//number
        this.model.doc.cuerpo.cs_id_334 = 0;//number
        this.model.doc.cuerpo.cs_id_335 = 0;//number
        this.model.doc.cuerpo.cs_id_336 = 0;//number
        this.model.doc.cuerpo.cs_id_337 = 0;//number
        this.model.doc.cuerpo.cs_id_338 = 0;//number
        this.model.doc.cuerpo.cs_id_339 = 0;//number
        this.model.doc.cuerpo.cs_id_340 = 0;//number
        this.model.doc.cuerpo.cs_id_341 = 0;//number
        this.model.doc.cuerpo.cs_id_342 = null;//Boolean
        this.model.doc.cuerpo.cs_id_343 = 0;//number
        this.model.doc.cuerpo.cs_id_316 = 0;//number
        this.model.doc.cuerpo.cs_id_345 = null;//Boolean
        this.model.doc.cuerpo.cs_id_346 = 0;//number
        this.model.doc.cuerpo.cs_id_347 = 0;//number
        this.model.doc.cuerpo.cs_id_664 = 0;//number
        this.model.doc.cuerpo.cs_id_669 = 0;//number

        this.model.doc.cuerpo.cs_id_310="0";//Indicador de Completo
        break;
      case 2:
        //TODO Completar campos
        this.model.doc.cuerpo.cs_id_277 = null;//seleccion
        this.model.doc.cuerpo.cs_id_278 = null;//Boolean
        this.model.doc.cuerpo.cs_id_279 = 0;//number
        this.model.doc.cuerpo.cs_id_280 = null;//Boolean
        this.model.doc.cuerpo.cs_id_281 = 0;//number
        this.model.doc.cuerpo.cs_id_282 = 0;//number
        this.model.doc.cuerpo.cs_id_283 = 0;//number
        this.model.doc.cuerpo.cs_id_284 = 0;//number
        this.model.doc.cuerpo.cs_id_284 = 0;//number
        this.model.doc.cuerpo.cs_id_286 = 0;//number
        this.model.doc.cuerpo.cs_id_286 = 0;//number
        this.model.doc.cuerpo.cs_id_288 = 0;//number
        this.model.doc.cuerpo.cs_id_290 = 0;//number
        this.model.doc.cuerpo.cs_id_291 = 0;//number
        this.model.doc.cuerpo.cs_id_292 = 0;//number
        this.model.doc.cuerpo.cs_id_293 = 0;//number
        this.model.doc.cuerpo.cs_id_294 = 0;//number
        this.model.doc.cuerpo.cs_id_295 = null;//Boolean
        this.model.doc.cuerpo.cs_id_296 = 0;//number
        this.model.doc.cuerpo.cs_id_297 = 0;//number
        this.model.doc.cuerpo.cs_id_298 = 0;//number
        this.model.doc.cuerpo.cs_id_299 = 0;//number
        this.model.doc.cuerpo.cs_id_300 = 0;//number
        this.model.doc.cuerpo.cs_id_301 = 0;//number
        this.model.doc.cuerpo.cs_id_302 = 0;//number
        this.model.doc.cuerpo.cs_id_303 = 0;//number
        this.model.doc.cuerpo.cs_id_304 = 0;//number
        this.model.doc.cuerpo.cs_id_305 = 0;//number
        this.model.doc.cuerpo.cs_id_306 = 0;//number
        this.model.doc.cuerpo.cs_id_307 = 0;//number
        this.model.doc.cuerpo.cs_id_308 = 0;//number
        this.model.doc.cuerpo.cs_id_310 = 0;//number
        this.model.doc.cuerpo.cs_id_311 = 0;//number
        this.model.doc.cuerpo.cs_id_316 = 0;//number
        this.model.doc.cuerpo.cs_id_317 = null;//Boolean
        this.model.doc.cuerpo.cs_id_318 = 0;//number
        this.model.doc.cuerpo.cs_id_319 = 0;//number
        this.model.doc.cuerpo.cs_id_320 = 0;//number
        this.model.doc.cuerpo.cs_id_321 = 0;//number
        this.model.doc.cuerpo.cs_id_322 = 0;//number
        this.model.doc.cuerpo.cs_id_323 = 0;//number
        this.model.doc.cuerpo.cs_id_324 = 0;//number
        this.model.doc.cuerpo.cs_id_325 = 0;//number
        this.model.doc.cuerpo.cs_id_326 = 0;//number
        this.model.doc.cuerpo.cs_id_327 = 0;//number
        this.model.doc.cuerpo.cs_id_328 = 0;//number
        this.model.doc.cuerpo.cs_id_329 = null;//Boolean
        this.model.doc.cuerpo.cs_id_330 = 0;//number
        this.model.doc.cuerpo.cs_id_331 = 0;//number
        this.model.doc.cuerpo.cs_id_332 = 0;//number
        this.model.doc.cuerpo.cs_id_333 = 0;//number
        this.model.doc.cuerpo.cs_id_334 = 0;//number
        this.model.doc.cuerpo.cs_id_335 = 0;//number
        this.model.doc.cuerpo.cs_id_336 = 0;//number
        this.model.doc.cuerpo.cs_id_337 = 0;//number
        this.model.doc.cuerpo.cs_id_338 = 0;//number
        this.model.doc.cuerpo.cs_id_339 = 0;//number
        this.model.doc.cuerpo.cs_id_340 = 0;//number
        this.model.doc.cuerpo.cs_id_341 = 0;//number
        this.model.doc.cuerpo.cs_id_342 = null;//Boolean
        this.model.doc.cuerpo.cs_id_343 = 0;//number
        this.model.doc.cuerpo.cs_id_316 = 0;//number
        this.model.doc.cuerpo.cs_id_345 = null;//Boolean
        this.model.doc.cuerpo.cs_id_346 = 0;//number
        this.model.doc.cuerpo.cs_id_347 = 0;//number
        this.model.doc.cuerpo.cs_id_664 = 0;//number
        this.model.doc.cuerpo.cs_id_669 = 0;//number

        this.model.doc.cuerpo.cs_id_311="0";//Indicador de Completo
        break;
    }
    console.log(this.model);
  }

  public validateComponentCompleted(): boolean{
    for(let i=0; i < questions.length; i++){
      if(questions[i].isCompleted==false){
        this.isCompleted.emit(false);
        return false;
      }
    }
    this.isCompleted.emit(true);//Componente completo!
    return true;
  }

  changeValue(data: any, index: number) {
    questions[index].resp = data.value.toString();
    this.model.doc.cuerpo[data.field] = data.value.toString();
    if(this.model.doc.cuerpo[data.field] == "0"){
      if(this.validateHasModalValues(index)){
        this.dNotificacionServicio.mostrarDialogoConfirmacion('Mensaje',"Está modificando su respuesta a 'No', pero ya existen datos ingresados para esta pregunta. Si confirma, los datos anteriores serán eliminados. ¿Está seguro de continuar?").afterClosed().subscribe(result => {
          if (result) {
            questions[index].isCompleted = true;
            this.cleanModalValues(index);
            this.validateComponentCompleted();
            this.saveModel.emit(true);
          }else{
            this.model.doc.cuerpo[data.field] == "";
          }
        });
      }else{
        questions[index].isCompleted = true;
        this.cleanModalValues(index);
        this.saveModel.emit(true);
      }
    }else if (this.model.doc.cuerpo[data.field] == "1"){
      questions[index].isCompleted = false;
      this.validateModalCompleted(index);//Valida antes de abrir el modal por si ya lo había completado para que siga mostrandolo completo
      this.openModal(index);
      this.saveModel.emit(true);
      
    }
    this.checkNextQuestion(index);
    this.validateComponentCompleted();
    console.log(data);
    console.log(this.model);
  }
}



// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/formulario-no-experto/secciones/renta-laboral/renta-laboral.component.ts